import { ClientFeatureAnnouncementList, ClientLatestFeatureAnnouncement } from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

export const getFeatureAnnouncements = async (queryParams: { offset: number; limit: number }) => {
    const { data } = await http.get(`${getApiUrl()}/feature-announcements`, { params: queryParams });

    return data as ClientFeatureAnnouncementList;
};

export const getLatestFeatureAnnouncement = async () => {
    const { data } = await http.get(`${getApiUrl()}/feature-announcements/latest`);

    return data as ClientLatestFeatureAnnouncement;
};

export const markFeatureAnnouncementSeen = async (featureAnnouncementId: string) => {
    await http.post(`${getApiUrl()}/feature-announcements/${featureAnnouncementId}/seen`);
};
